import React from 'react';
import * as Sentry from '@sentry/browser';
import { injectIntl, WrappedComponentProps, defineMessages } from 'react-intl';
import styled from 'styled-components/macro';
import Grid from '@material-ui/core/Grid';
import { Typography, Button } from '@deeptrue-frontend/ui';
import { ReactComponent as Logo } from 'assets/images/logo.svg';
import env from 'consts/env';

const messages = defineMessages({
  errMsg: {
    id: 'pages.errorBoundary',
    defaultMessage: 'Whoops, we having an isssue',
  },
  report: {
    id: 'pages.errorBoundary.report',
    defaultMessage: 'Report feedback',
  },
});

const StyledLogo = styled(Logo)`
  color: #1f5dea;
  width: 300px;
  margin-bottom: 32px;
`;

class Error extends React.Component<WrappedComponentProps> {
  state = {
    eventId: null,
    hasError: false,
  };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: any, errorInfo: any) {
    if (env.IS_PRODUCTION) {
      Sentry.withScope((scope) => {
        scope.setExtras(errorInfo);
        const eventId = Sentry.captureException(error);
        this.setState({ eventId });
      });
    }
  }

  render() {
    const { eventId, hasError } = this.state;
    // @ts-ignore KRZYŚ
    const { intl, children } = this.props;

    if (hasError) {
      return (
        <Grid
          container
          direction="column"
          justify="center"
          alignItems="center"
          style={{ height: '100vh' }}
        >
          <StyledLogo />
          <Typography variant={'copy1'} mt={1} mb={3}>
            {intl.formatMessage(messages.errMsg)}
          </Typography>
          {env.IS_PRODUCTION && (
            <Button
              style={{ marginTop: '2rem' }}
              onClick={() =>
                Sentry.showReportDialog({ eventId: eventId || '' })
              }
            >
              {intl.formatMessage(messages.report)}
            </Button>
          )}
        </Grid>
      );
    }
    return children;
  }
}

export default injectIntl(Error);
